import {
    ITEMS_FETCH_SUCCESS,
    CATEGORIES_FETCH_SUCCESS
} from '../action/actionType'

const initialState = {categories: []}

function categoryReducer(state = initialState, action){
    switch(action.type){
        case CATEGORIES_FETCH_SUCCESS:
            return {...state, categories: action.payload};
        default:
            return state;
    }
}

export default categoryReducer